import React from "react";

export const BettoFullscreenIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		aria-hidden="true"
		{...props}>
		<path
			d="M2.25 6.75V2.25H6.75M11.25 2.25H15.75V6.75M15.75 11.25V15.75H11.25M6.75 15.75H2.25V11.25"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const BettoRefreshIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		aria-hidden="true"
		{...props}>
		<path
			d="M14.25 9C14.25 11.8995 11.8995 14.25 9 14.25C6.10051 14.25 3.75 11.8995 3.75 9C3.75 6.10051 6.10051 3.75 9 3.75C10.5913 3.75 12.0174 4.38214 13.045 5.4375M13.045 5.4375V2.25M13.045 5.4375H9.795"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const BettoCloseIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		aria-hidden="true"
		{...props}>
		<path
			d="M4.5 4.5L13.5 13.5M13.5 4.5L4.5 13.5"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
);

export const BettoFavoriteIcon = ({ filled, ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill={filled ? "currentColor" : "none"}
		aria-hidden="true"
		{...props}>
		<path
			d="M9 14.25L3.9375 9.5625C2.4375 8.175 2.325 5.8875 3.675 4.35C5.025 2.8125 7.3125 2.625 8.8875 3.9375L9 4.03125L9.1125 3.9375C10.6875 2.625 12.975 2.8125 14.325 4.35C15.675 5.8875 15.5625 8.175 14.0625 9.5625L9 14.25Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinejoin="round"
		/>
	</svg>
);
